import React, { Component } from 'react';
import {Form,Select,Input,Icon,Button,message} from 'antd';
import {pepoleWip,newUser} from '../../stores/APIEndpoints';
import DynamicForm from "../DynamicForm";
import looseLeafStore from "../../stores/LooseLeafStore";
import {appStore} from '../../stores/AppStore';
import {inject, observer} from 'mobx-react';
import DashboardStore from '../../stores/DashboardStore';
const { Option } = Select;
import '../../../src/index.css';
import moment from 'moment';



class NewUserCreate extends Component {
  
    constructor(props) {
        super(props);
        this.apiProxy = appStore.apiProxy;
        this.state = {}
    }

    handleSubmit = e => {
      e.preventDefault();
      this.props.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
        
          const bodyParams = {
            "name" : values.username,
            "email" : values.email,
          }
          this.userRegister(bodyParams);
        }
      });
    };
   userRegister= async(bodyParams) =>{
    let response = await this.apiProxy.asyncPost(newUser, bodyParams);
    const option = await response.json();
  
    if(option.message == "User already exists")
    {
      message.error('User already exists');
    }
    else if(option.messages == "User created Successfully")
    {
      message.success('User created Successfully');
    }
   }
  
  render() {
   
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
    };
        return (
          <Form name="normal_login" className="login-form"  {...formItemLayout} onSubmit={this.handleSubmit}>
         <Form.Item label="User Name">
              {getFieldDecorator('username', {
                  rules: [{ required: true, message: 'Please input your username!' }],
              })(
                  <Input
                      prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                      placeholder="Username"
                  />,
              )}
          </Form.Item>
          <Form.Item label="E-mail">
              {getFieldDecorator('email', {
                  rules: [
                  {
                      type: 'email',
                      message: 'The input is not valid E-mail!',
                  },
                  {
                      required: true,
                      message: 'Please input your E-mail!',
                  },
                  ],
              })(
              <Input 
                  prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  placeholder="Username" />)}
                  <Button type="primary" htmlType="submit" className="login-form-button">
                  Register
              </Button>
          </Form.Item>
          </Form>
        );
      }
     
   
  }


export default Form.create({ name: 'normal_login' })(NewUserCreate);

// export default WrappedNormalLoginForm;

